import "babel-polyfill";
import "details-polyfill";
import React from "react";
import { hydrate } from "react-dom";
import {
  Header,
  Footer,
  WelcomeWrapper,
  updateStateWithClientData
} from "./Root";
import startIframe from "./thirdPartyCookie";

document.addEventListener("DOMContentLoaded", function() {
  const headerElement = document.getElementById("chrome-header");
  const footerElement = document.getElementById("chrome-footer");
  const welcomeMatElement = document.getElementById("chrome-welcome-mat");

  hydrate(<Header />, headerElement);
  hydrate(<Footer />, footerElement);
  hydrate(<WelcomeWrapper />, welcomeMatElement);

  updateStateWithClientData();
});

startIframe();

// https://www.w3.org/TR/navigation-timing/#sec-navigation-info-interface
// https://www.w3.org/TR/navigation-timing/#processing-model
const attributes = {
  type: window.performance.navigation.type,
  ...JSON.parse(JSON.stringify(window.performance.timing)), // Performance.toJSON is not supported in all browsers
  now: Date.now()
};

// https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/add-page-action
window.NREUM && window.NREUM.addPageAction("siteChromePerformance", attributes);



// WEBPACK FOOTER //
// ./client/index.js